import {Injectable, Pipe, PipeTransform} from '@angular/core'

@Pipe({
  name: 'ldNotNull'
})
@Injectable()
export class NotNullPipe implements PipeTransform {
  transform (items: any[], args: any[]): any {
    return typeof items === 'undefined' ? [] : items.filter(item => item)
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/pipes/notNull.pipe.ts